export interface BigIntegerDatatypeInterface extends Number {
  data?: number;
}

export class BigIntegerDatatypeClass extends Number
  implements BigIntegerDatatypeInterface {
  data?: number;
}
